<template>
    <div class="xxdata">
        <vx-card title="">

            <div class="p-6" style="xxmax-width: 300px;">
                <table class="td-w100">
                    <tr>
                        <td class="font-semibold">类型</td>
                        <td>{{ '客户' }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">名称</td>
                        <td>{{ user_data.name }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">编号</td>
                        <td>{{ user_data.outCode }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">类别</td>
                        <td>{{ user_data.type }}</td>
                    </tr>
                </table>
            </div>
            <div class="p-6" style="xxxmax-width: 300px;">
                <div class="mt-5">
                    <vs-button type="border" color="danger" @click="closeForm">返回</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import GcCmpVsSubmitButton from "@/group-cloud/components/vsButton.submit";
    import GcCmpVsInput from "@/group-cloud/components/vsInput";
    import {GC_Validator} from "@/group-cloud/components/validator/Validator";
    import GcCmpFormSelect from "@/group-cloud/components/form/select/GC-Cmp-Select";
    import {Mod_Account} from '@/modules/server-api/Accounts';
    import {Mod_Account_Types} from '@/modules/server-api/Accounts';
    import {Mod_Clients} from "../../server-api/Clients";
    import {Navigator} from "@/router/Navigator";

    export default {
        components: {
            GcCmpFormSelect,
            GcCmpVsInput,
            GcCmpVsSubmitButton,
        },
        data () {
            return {
                user_id: 0,
                model: {
                    role: '',
                    name: '',
                    phone: '',
                    password: ''
                },
                user_data: {
                    user_type: '',
                    real_name: '',
                    phone: '',
                    role: '',
                    outCode:'',
                    type:'',
                    name:''
                },
                roles: [],
                loaded: false
            }
        },
        computed: {
            passwordPlaceHolder() {
                return  this.user_id > 0 ? '留空保持密码不变' : '设置初始密码';
            },
            getSaveUrl() {
                return  this.user_id > 0 ? 'auth_center/yooz/member/modify' : 'auth_center/yooz/member/add_user';
            },
            getParam() {
                let param = {
                    username: this.model.phone,
                    password: this.model.password,
                    real_name: this.model.name,
                    role_id: [this.model.role],
                    user_type: Mod_Account_Types.HEAD_QUARTER,
                    add_by_id: '',
                    user_code: '',
                    mail: '',
                    phone: this.model.phone,
                    position: '',
                    user_id: 0,
                };
                if (this.user_id > 0) {
                    param.user_id = this.user_id;
                }
                return param;
            },
        },
        methods: {
            validate() {

                return true;
            },

            async getRoles() {
                let resp = await Mod_Account.getRoles(Mod_Account_Types.CLIENT);
                if (resp && resp.length) {
                    this.roles = resp;
                }
                return resp;
            },

            async loadUser(uid) {
                let resp = await Mod_Clients.getClientInfo(uid);
                // console.log(['user-client', resp]);
                if (resp.id > 0) {
                    this.user_data = resp;
                }
                return resp;
            },

            closeForm() {
                let path = `/modules/clients/list`;
                Navigator.redirect(path);
            }
        },
        created() {
            // if (this.$route.params.client_id > 0) {
            //     this.user_id = parseInt(this.$route.params.client_id);
            //     this.loadUser(this.user_id);
            // }
            // this.getRoles();
            if(this.$route.query.rowData){
                console.log(this.$route.query.rowData,"当前行数据")
                this.user_data=this.$route.query.rowData
            }
        }
    }
</script>

<style lang="scss" scoped>

    table.td-w100 {
        td {
            min-width: 100px;
        }
    }

</style>


